interface IimgResize {
  (url: string, resizeWidth: number, resizeHeight?: number): string
}

const imgResize: IimgResize = function (url, resizeWidth, resizeHeight) {
  try {
    const baseStr = `w_${resizeWidth}${resizeHeight ? `,h_${resizeHeight}` : ''}`
    const hasQuery = /\?[\s\S]*/.exec(url)
    const query = hasQuery ? hasQuery[0] : ''
    if (!hasQuery) {
      return `${url}?x-oss-process=image/resize,${baseStr}`
    }

    const hasOssQuery = query.includes('x-oss-process')
    if (!hasOssQuery) {
      return `${url}&x-oss-process=image/resize,${baseStr}`
    }

    const hasResize = query.includes('image/resize')
    if (hasResize) return url

    return url.replace(/(?:\?|&)x-oss-process=([^&]*)(?:&|$)/, function (...args) {
      if (!args[1]) {
        return `${args[0]}image/resize,${baseStr}`
      }
      return args[0].replace(args[1], `image/resize,${baseStr}`)
    })
  } catch (error) {
    console.warn(error.message)
    return url
  }
}
export default imgResize
